/** An unexplained difference, named (CTX-04) — moved out of `Reports.tsx` unchanged. */

import { Link } from "@tanstack/react-router";

import type { Report } from "../api/queries";
import own from "./Reports.module.css";
import { cls } from "./reportsFormat";
import { keepSearch } from "./search";

export function Unreconciled({ report }: { report: Report }) {
  return (
    <>
      {/* **An unexplained difference, named - CTX-04.** It is a *field* and not part of
          `verdict_reason`, because the reason's blocking branch returns first and on a filing
          that also has a failing rule check the gap would be named in no element at all. It is
          not a `finding` either: no paragraph of either regime says a company's numbers must
          agree with last year's, which is why `validation.check` takes the set as a separate
          argument. Without this block a filer reads "2 checks have not passed" and has nowhere
          to go - the hunting that EXP-29 is about. The link is the screen that owns the
          question. */}
      {report.unreconciled.length > 0 ? (
        <div data-testid="unreconciled">
          {report.unreconciled.map((difference) => (
            <p key={difference.disclosure_key} className={cls(own.notice, own.noticeWarn)}>
              <span className={cls(own.noticeTitle)}>Unexplained difference</span>
              {difference.disclosure_key} differs from what was disclosed by{" "}
              <span className="num">{difference.delta}</span> {difference.unit}. Nobody has
              written down why.{" "}
              <Link
                to="/prior-disclosures"
                search={(prev: Record<string, unknown>) => keepSearch(prev)}
              >
                Explain it on Prior disclosures
              </Link>
              .
            </p>
          ))}
        </div>
      ) : null}
    </>
  );
}
